(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4499],{

/***/ 51477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ios/setup",
      function () {
        return __webpack_require__(7345);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2261);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66832);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4839);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24576);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89995);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__);









// 备份提示步骤集合
const backupArr = [
    {
        url: "/images/ios-backup/step1.webp",
        alt: "backup-step1",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Open the Settings of the target device and click on the account name"
    },
    {
        url: "/images/ios-backup/step2.webp",
        alt: "backup-step2",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Tap iCloud"
    },
    {
        url: "/images/ios-backup/step3.webp",
        alt: "backup-step3",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Select iCloud Backup"
    },
    {
        url: "/images/ios-backup/step4.webp",
        alt: "backup-step4",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Tap the slider next to iCloud Backup If its green youll know youve turned on iCloud backup and you can skip to the next step"
    },
    {
        url: "/images/ios-backup/step5.webp",
        alt: "backup-step5",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Make sure to enable syncing for all the apps you want to monitor"
    },
    {
        url: "/images/ios-backup/step6.webp",
        alt: "backup-step6",
        width: "371px",
        height: "379px",
        mbWidth: "325px",
        mbHeight: "332px",
        text: "Finally click Back Up Now Wait until the backup process complete While your iPhone is backing up your data You must remain connected to Wi-Fi"
    },
    {
        url: "/images/ios-backup/step7.webp",
        alt: "backup-step7",
        width: "421px",
        height: "379px",
        mbWidth: "325px",
        mbHeight: "293px",
        text: "Make sure there is enough storage left in the target iCloud account When the iCloud is full you can only see the previous backup data if you wanna view more data you can consider upgrading the iCloud storage plan"
    },
    {
        url: "/images/ios-backup/step8.png",
        alt: "backup-step8",
        width: "180px",
        height: "379px",
        mbWidth: "180px",
        mbHeight: "379px",
        text: "Turn on the Access iCloud Data on Web toggle"
    }
];
const StepProgress = (param)=>{
    let { current , total  } = param;
    const barWidth = 72; //宽度
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center gap-4 mb-[40px] Mlg:mb-[20px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                children: [
                    current,
                    "/",
                    total
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex gap-x-[6px]",
                children: Array.from({
                    length: total
                }).map((_, i)=>{
                    const active = i < current;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]",
                        style: active ? {
                            background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                            backgroundSize: "".concat(current * barWidth, "px 4px"),
                            backgroundPosition: "-".concat(i * barWidth, "px 0px")
                        } : {
                            background: "#E8EDFF"
                        }
                    }, i);
                })
            })
        ]
    });
};
const Backup = (param)=>{
    let { setJustVerified2  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const [current, setCurrent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 当前的步骤
    ;
    const [innerWidth, setInnerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 实时屏幕宽度
    ;
    const prevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 上一步按钮
    ;
    const nextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 下一步按钮
    ;
    const paginationRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 圆点导航按钮
    ;
    // 监听屏幕宽度
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full max-w-[648px] h-max px-[10px] flex flex-col items-center relative Mlg:pb-[75px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepProgress, {
                current: 5,
                total: 5
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/images/apps/apple.svg",
                alt: "img",
                className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]",
                style: {
                    opacity: current === backupArr.length ? "0" : "100"
                },
                width: "60",
                height: "69"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "w-full max-w-[420px] mt-[24px] text-[30px] Mlg:text-[20px] text-[#2405F2] text-center font-[600] leading-[40px] Mlg:leading-[30px]",
                style: {
                    opacity: current === backupArr.length ? "0" : "100"
                },
                children: t("Turn on the iCloud Backup")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-max max-w-full my-[16px] flex items-start justify-center text-[14px] Mlg:text-[10px] text-[#F11E34] leading-[21px] Mlg:leading-[15px] p-[8px_18px_8px_16px] Mlg:p-[14px_17px_11px] bg-[#FF00000D] rounded-[6px]",
                style: {
                    opacity: current === backupArr.length ? "0" : "100"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/images/apps/waring.svg",
                        className: "flex items-start mt-[5px] Mlg:mt-[3px] mr-[6px]",
                        alt: "img",
                        width: 12,
                        height: 12
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-center",
                        children: t("You can only get all data if iCloud is turned on")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                modules: [
                    swiper_modules__WEBPACK_IMPORTED_MODULE_5__/* .Navigation */ .W_,
                    swiper_modules__WEBPACK_IMPORTED_MODULE_5__/* .Pagination */ .tl
                ],
                direction: "horizontal",
                allowTouchMove: false,
                navigation: {
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                },
                onBeforeInit: (swiper)=>{
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.params.pagination.el = paginationRef.current;
                    swiper.params.pagination.renderBullet = (_, className)=>'<div class="'.concat(className, ' myBullet"></div>');
                },
                pagination: {
                    clickable: true,
                    el: paginationRef.current,
                    renderBullet: (_, className)=>{
                        return '<div class="'.concat(className, ' myBullet"></div>');
                    }
                },
                onSlideChange: (swiper)=>{
                    setCurrent(swiper.realIndex);
                },
                className: "w-full max-w-[500px] relative",
                style: {
                    top: current === backupArr.length ? "-122px" : "0px"
                },
                children: [
                    backupArr.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                            className: "h-full flex flex-col justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[379px] mb-[48px] flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.url,
                                        alt: item.alt,
                                        width: 100,
                                        height: 100,
                                        style: {
                                            width: innerWidth > 768 ? item.width : item.mbWidth,
                                            height: innerWidth > 768 ? item.height : item.mbHeight
                                        },
                                        className: "object-cover object-left-top [box-shadow:0px_4px_18px_0px_#00000033] select-none"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "w-full text-[14px] text-[#000000] text-center leading-[22px]",
                                    children: t(item.text)
                                })
                            ]
                        }, index)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: paginationRef,
                        className: "!h-[8px] flex justify-center items-center gap-x-[5px] absolute !top-[403px] !left-[50%] !-translate-x-[50%] z-20 ".concat(current === backupArr.length ? "hidden" : "")
                    })
                ]
            }, innerWidth <= 768 ? "mobile" : "desktop"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB] z-[1]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                ref: prevRef,
                                className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px] ".concat(current == 0 && "opacity-0"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "mr-[7px]",
                                        src: "/images/bind/bind-arrow-blue.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#454CFF] font-[600]",
                                        children: t("BACK")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                ref: nextRef,
                                className: "bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ".concat(current == backupArr.length - 1 && "hidden"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#1B1C2B] font-[600]",
                                        children: t("NEXT")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "ml-[6px]",
                                        src: "/images/bind/bind-arrow-black.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: ()=>{
                                    if (current == backupArr.length - 1) setJustVerified2(true);
                                },
                                className: "bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ".concat(current == backupArr.length - 1 || "hidden"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#1B1C2B] font-[600]",
                                        children: t("NEXT")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "ml-[6px]",
                                        src: "/images/bind/bind-arrow-black.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Backup);


/***/ }),

/***/ 7595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ MessageInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2453);


const MessageInfo = (param)=>{
    const key = Date.now();
    const isObject = param && typeof param === "object" && !Array.isArray(param);
    const type = (isObject ? param.type : null) || "remind";
    const duration = (isObject ? param.duration : null) || 3;
    const src = type === "success" ? "/image/success.svg" : type === "error" ? "/image/error.svg" : type === "warn" ? "/image/warn.svg" : "/image/remind.svg";
    var _content;
    const text = isObject ? (_content = param.content) !== null && _content !== void 0 ? _content : "" : param;
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-[340px] w-full flex items-center gap-x-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: src,
                alt: "",
                width: 24,
                height: 24
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-[14px] leading-[22px] text-[#484B60]",
                children: text
            })
        ]
    });
    antd__WEBPACK_IMPORTED_MODULE_1__/* ["default"].open */ .ZP.open({
        content,
        key,
        duration
    });
};



/***/ }),

/***/ 7345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ setup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
;// CONCATENATED MODULE: ./src/components/ios-extreme/preparation/index.js





const Preparation = (props)=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const [checked, setChecked] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "Mlg:px-[24px] max-w-[435px] w-full flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[#282938] Mlg:mt-[14px] text-center flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[24px] leading-[36px] font-semibold",
                        children: t("Before you begin")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[18px] leading-[26px] font-medium mt-[10px]",
                        children: t("Preparation for successful Connection")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[374px] w-full mt-[24px] flex items-start justify-center p-[12px] bg-[#FFFFFF] rounded-[8px] shadow-[0px_1px_6px_0px_#28293826]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/apps/hint.svg",
                        className: "flex w-[24px] h-[24px] mr-[12px]",
                        alt: "img",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[14px] leading-[22px] Mlg:text-[12px] Mlg:leading-[20px] text-[#282938]",
                        children: [
                            t("Please note that all information and devices mentioned below refer to the"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: t("target device")
                            }),
                            " ",
                            t("you wish to monitor not your own phone")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Mlg:mt-[16px] mt-[32px] flex flex-col justify-start gap-y-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-[600]",
                                children: t("iCloud account and password of the target device")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center p-[10px] rounded-[8px] bg-[linear-gradient(90deg,#6B51FE_0%,#06BAFD_100%)] text-[12px] leading-[20px] font-normal text-[#FFFFFF]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("Not sure which account to use")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/images/apps/user.svg",
                                        className: "w-[18px] h-[18px] mr-[10px]",
                                        alt: "help",
                                        width: 18,
                                        height: 18
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://support.apple.com/en-us/102627",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "cursor-pointer underline",
                                        children: t("Find it here")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#484B60] font-normal",
                                children: t("Devices or phone numbers trusted by the iCloud account for two-factor authentication")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#484B60] font-normal",
                                children: t("Stable internet connection")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#484B60] font-normal",
                                children: t("5 minutes of uninterrupted time")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mt-[86px] smj:mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        checked: checked,
                        onChange: ()=>{
                            const nextChecked = !checked;
                            setChecked(nextChecked);
                        },
                        className: " appearance-none w-[16px] h-[16px] border border-[#165DFF] rounded-[2px] cursor-pointer transition-all duration-200 checked:bg-[#165DFF] checked:border-[#165DFF] checked:bg-[url('/images/apps/shape.svg')] checked:bg-no-repeat checked:bg-center checked:bg-[length:10px_10px] focus:outline-none "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "ml-[6px] text-[#282938] text-[12px] leading-[20px]",
                        children: t("I have all the above items ready")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[266px] Mlg:w-full flex justify-center items-center mt-[16px] Mlg:pb-[32px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    disabled: !checked,
                    className: "w-full h-[60px] Mlg:h-[50px] mx-auto text-[#282938] text-[16px] font-[600] rounded-[41px] flex justify-center items-center\n                      bg-[#FFCF55]\n                      ".concat(!checked ? "opacity-30 cursor-not-allowed" : "cursor-pointer", "\n                    "),
                    onClick: ()=>{
                        if (!checked) return;
                        props.onStart();
                    },
                    children: t("Start to connect")
                })
            })
        ]
    });
};
/* harmony default export */ var preparation = (Preparation);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 14 modules
var input = __webpack_require__(96456);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(57381);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 40 modules
var es_select = __webpack_require__(13573);
// EXTERNAL MODULE: ./src/components/pop-up-window/index.js
var pop_up_window = __webpack_require__(7595);
// EXTERNAL MODULE: ./src/@api/android.js
var android = __webpack_require__(19630);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var _api_login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
// EXTERNAL MODULE: ./src/utils/bindingDeviceResult.js
var bindingDeviceResult = __webpack_require__(45210);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/ios-extreme/basic-verfiy/style.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: wrap;\n\n    .ant-select .ant-select-selector {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        border: none;\n        border-radius: 26px;\n        background: #F5F6F7;\n        box-shadow: none !important;\n    }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const IosVerfiyBasicCommponents = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
/* harmony default export */ var style = ((/* unused pure expression or super */ null && (IosVerfiyBasicCommponents)));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudLockedFlow.js + 3 modules
var useIcloudLockedFlow = __webpack_require__(82000);
// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify.js
var useIcloudCredentialReverify = __webpack_require__(56148);
// EXTERNAL MODULE: ./src/utils/icloudLoginResult.js
var icloudLoginResult = __webpack_require__(83469);
;// CONCATENATED MODULE: ./src/components/ios-extreme/basic-verfiy/index.js




















const getLoginCountry = ()=>{
    try {
        var ref, ref1, ref2;
        const userData = JSON.parse(localStorage.getItem("userData"));
        return (userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.country_name) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.toLocaleLowerCase) === null || ref2 === void 0 ? void 0 : ref2.call(ref1)) || "";
    } catch (e) {
        return "";
    }
};
const CodeBox = dynamic_default()(__webpack_require__.e(/* import() */ 7537).then(__webpack_require__.bind(__webpack_require__, 87537)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87537)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});
const BasicVerfiy = (param)=>{
    let { setBasicOver =()=>{} , goBack  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const [useUserName, setUserName] = (0,react.useState)("") // iCloud账号
    ;
    const [usePassWord, setPassWord] = (0,react.useState)("") // iCloud密码
    ;
    const [loginLoading, setLoginLoading] = (0,react.useState)(false) // 账号密码验证中状态
    ;
    const [modalOpen, setModalOpen] = (0,react.useState)(false) // 发送短信弹窗
    ;
    const [current, setCurrent] = (0,react.useState)(0) // 当前验证的步骤，填写账号密码 or 填写验证码
    ;
    const [innerWidth, setInnerWidth] = (0,react.useState)(0) // 实时屏幕宽度
    ;
    const [showAgreeTerms, setShowAgreeTerms] = (0,react.useState)(false) //icoud登录协议
    ;
    const [defaultSmsPhone, setDefaultSmsPhone] = (0,react.useState)({});
    const [smsId, setSmsId] = (0,react.useState)("");
    const [smsPhoneList, setSmsPhoneList] = (0,react.useState)([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = (0,react.useState)(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = (0,react.useState)(true);
    const [key, setKey] = (0,react.useState)("1");
    const [smsErrorText, setSmsErrorText] = (0,react.useState)("") // icloud没有绑定手机号错误提示文案
    ;
    const [codeErrorText, setCodeErrorText] = (0,react.useState)("") // 验证码错误（接口 em）
    ;
    const [codeBoxKey, setCodeBoxKey] = (0,react.useState)(0) // 错误后重置输入框
    ;
    const [sendTime, setSentTime] = (0,react.useState)(60);
    const [sendContentTips, setSendContentTips] = (0,react.useState)("");
    const [btnDisable, setBtnDisable] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    // 验证码提交锁：防止 CodeBox 重复 onChange / 绑定未完成时再次触发
    const codeSubmitLockRef = (0,react.useRef)(false);
    // auth/login 成功后调 user-binding-device，需带 order_id
    // 返回 success | already_bound | false（失败）
    const bindVerifiedICloudDevice = async (username, password)=>{
        const orderId = await (0,resolveCurrentOrderId/* resolveBindOrderIdWithFeedback */.O7)(t, (opts)=>(0,pop_up_window/* MessageInfo */.L)({
                type: "error",
                ...opts
            }));
        if (!orderId) {
            return false;
        }
        let bindingResult;
        try {
            bindingResult = await (0,_api_login.userBindingDevice)({
                username,
                password,
                order_id: orderId,
                verify: 1,
                platformType: "iOS-Cloud"
            });
        } catch (e) {
            ;
            const isTimeout = typeof (e === null || e === void 0 ? void 0 : e.message) === "string" && (e.message.includes("timeout") || e.message.includes("Request timed out"));
            (0,pop_up_window/* MessageInfo */.L)({
                content: isTimeout ? t("Request timed out") || "Request timed out" : t("Network error, please try again"),
                type: "error"
            });
            return false;
        }
        const { outcome , shouldContinue  } = (0,bindingDeviceResult/* resolveBindingDeviceResponse */.Ln)(bindingResult, {
            platformType: "iOS-Cloud",
            router,
            t,
            onMessage: (opts)=>(0,pop_up_window/* MessageInfo */.L)(opts)
        });
        if (outcome === bindingDeviceResult/* BINDING_OUTCOME.ALREADY_BOUND */.iQ.ALREADY_BOUND) {
            return bindingDeviceResult/* BINDING_OUTCOME.ALREADY_BOUND */.iQ.ALREADY_BOUND;
        }
        if (!shouldContinue) {
            return false;
        }
        return bindingDeviceResult/* BINDING_OUTCOME.SUCCESS */.iQ.SUCCESS;
    };
    // download/web 只触发后台下载，code 268435457 为「下载中」正常态
    const triggerBasicDownload = (username, password)=>{
        (0,_api_login.downloadWeb)({
            mode: 1,
            username,
            password
        }).then((res)=>{
            var ref;
            const tip = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.ed;
            if (tip) {
                (0,pop_up_window/* MessageInfo */.L)({
                    content: tip,
                    duration: 8
                });
            }
            return (0,_api_login.sendDownloadTime)({
                username,
                type: "basic_download"
            });
        }).then(()=>{
            setTimeout(()=>{
                dispatch((0,Common/* fetchResetTime */.NZ)());
            }, 800);
        }).catch((e)=>{
            ;
        });
    };
    // auth/login 成功 → 绑定 → 进下一步；download 异步触发
    const finishBasicVerification = async (param)=>{
        let { username , password , deviceUserObj , verifyMethod , trackConnectCreds =false  } = param;
        try {
            const bindOutcome = await bindVerifiedICloudDevice(username, password);
            if (bindOutcome === bindingDeviceResult/* BINDING_OUTCOME.ALREADY_BOUND */.iQ.ALREADY_BOUND) {
                return false;
            }
            if (bindOutcome !== bindingDeviceResult/* BINDING_OUTCOME.SUCCESS */.iQ.SUCCESS) {
                return false;
            }
            window.localStorage.setItem("Basic", 1);
            if (deviceUserObj) {
                window.localStorage.setItem("DeviceUser", JSON.stringify(deviceUserObj));
            } else {
                // 验证码成功后确保 DeviceUser 仍有账号密码
                const prev = JSON.parse(window.localStorage.getItem("DeviceUser") || "{}");
                window.localStorage.setItem("DeviceUser", JSON.stringify({
                    ...prev,
                    username,
                    password
                }));
            }
            dispatch((0,Common/* changeDownloadTips */.em)(true));
            dispatch((0,Common/* changeBasicVerfiyOver */.yT)(true));
            if (trackConnectCreds) {}
            setBasicOver(true);
            // 绑定已完成，下载不阻塞页面
            triggerBasicDownload(username, password);
            return true;
        } catch (e) {
            ;
            (0,pop_up_window/* MessageInfo */.L)({
                content: t("Network error, please try again"),
                type: "error"
            });
            return false;
        }
    };
    /** 兼容 { data: { ec } } 与顶层 { ec, status } 两种登录响应 */ const getIcloudLoginPayload = (res)=>{
        if (!res) return null;
        if (res.data != null && typeof res.data === "object" && (res.data.ec != null || res.data.status != null)) {
            return res.data;
        }
        if (res.ec != null || res.status != null) return res;
        var _data;
        return (_data = res.data) !== null && _data !== void 0 ? _data : null;
    };
    const onChange = async (key)=>{
        if (key == 2) {
            let check = sessionStorage.getItem("icloudPhoneSmsList");
            let result = {};
            if (check) {
                result = JSON.parse(check);
            } else {
                let mode = 1;
                result = await (0,_api_login.authInfo)({
                    mode: mode,
                    username: useUserName,
                    password: usePassWord
                });
                sessionStorage.setItem("icloudPhoneSmsList", JSON.stringify(result));
            }
            setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber);
            setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || "0");
            let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map((item)=>{
                return {
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                };
            });
            setSmsPhoneList(mapData);
            setSmsPhoneListDisabled(false);
            setSmsPhoneListLoading(false);
        }
    };
    // 登录 iCloud 账号
    const login = async ()=>{
        if (useUserName === "" || usePassWord === "") {
            (0,pop_up_window/* MessageInfo */.L)({
                content: t("Value cannot be empty"),
                type: "error"
            });
            return;
        }
        //埋点上报
        let mode = 1;
        let obj = {
            mode: mode,
            username: useUserName,
            password: usePassWord,
            country: getLoginCountry()
        };
        setLoginLoading(true);
        let loginResponse;
        try {
            loginResponse = await (0,_api_login.iosLoginVerification)(obj);
        } catch (e) {
            ;
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)({
                content: t("Network error, please try again"),
                type: "error"
            });
            return;
        }
        const data = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data;
        if (!data) {
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)({
                content: t("Network error, please try again"),
                type: "error"
            });
            return;
        }
        // 上传ios日志
        (0,_api_login.iosLoginReport)({
            "platform": "ios-icloud",
            "site": "spyx",
            "s_2": 1
        });
        if (data.ec === icloudLoginResult/* ICLOUD_EC.PASSWORD */.VO.PASSWORD) {
            setLoginLoading(false);
            handlePasswordError(data.ec);
            (0,pop_up_window/* MessageInfo */.L)({
                content: data.em,
                type: "error"
            });
        } else if (data.ec === icloudLoginResult/* ICLOUD_EC.TWO_STEP */.VO.TWO_STEP) {
            var ref;
            (0,_api_login.iosLoginReport)({
                "platform": "ios-icloud",
                "site": "spyx",
                "s_3": 1
            });
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)(data.em);
            window.localStorage.setItem("DeviceUser", JSON.stringify(obj));
            setCurrent(1);
            if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
            if ((ref = data === null || data === void 0 ? void 0 : data.trustedPhoneNumbers[0]) === null || ref === void 0 ? void 0 : ref.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
                } else {
                    setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
                }
            }
            setSmsPhoneListLoading(false);
        //埋点上报
        } else if (data.ec === icloudLoginResult/* ICLOUD_EC.LOCKED */.VO.LOCKED) {
            setLoginLoading(false);
            await handleEc10005({
                username: useUserName,
                password: usePassWord
            });
        } else if ((0,icloudLoginResult/* isIcloudOk */.UR)(data)) {
            (0,_api_login.iosLoginReport)({
                "platform": "ios-icloud",
                "site": "spyx",
                "s_4": 1
            });
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)({
                content: data.em,
                type: "success",
                duration: 8
            });
            await finishBasicVerification({
                username: useUserName,
                password: usePassWord,
                deviceUserObj: obj,
                verifyMethod: "Device",
                trackConnectCreds: true
            });
        } else if (data.ec === icloudLoginResult/* ICLOUD_EC.TERMS */.VO.TERMS) {
            setLoginLoading(false);
            setShowAgreeTerms(true);
        } else {
            (0,pop_up_window/* MessageInfo */.L)({
                content: data.em,
                type: "error"
            });
            setLoginLoading(false);
        }
    };
    // 设备验证码验证
    const codeDevice = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (!check) return;
        if (loginLoading || codeSubmitLockRef.current) return;
        setCodeErrorText("");
        codeSubmitLockRef.current = true;
        setLoginLoading(true);
        try {
            let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
            deviceUser.securityCode = securityCode;
            let verify;
            try {
                verify = await (0,_api_login.iosLoginVerification)({
                    mode: 1,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    country: getLoginCountry()
                });
            } catch (err) {
                ;
                const tip = t("Network error, please try again");
                setCodeErrorText(tip);
                codeSubmitLockRef.current = false;
                return;
            }
            const payload = getIcloudLoginPayload(verify);
            if (!payload) {
                const tip1 = t("Network error, please try again");
                setCodeErrorText(tip1);
                codeSubmitLockRef.current = false;
                return;
            }
            if ((0,icloudLoginResult/* isIcloudOk */.UR)(payload) || payload.status === true) {
                (0,_api_login.iosLoginReport)({
                    platform: "ios-icloud",
                    site: "msafely",
                    s_4: 1
                });
                const ok = await finishBasicVerification({
                    username: useUserName,
                    password: usePassWord,
                    verifyMethod: key === "2" ? "SMS" : "Device"
                });
                // 绑定失败允许重试；成功进下一步后组件会卸载，锁可保持
                if (!ok) codeSubmitLockRef.current = false;
            } else {
                handlePasswordError(payload.ec);
                const tip2 = payload.em || t("Incorrect verification code Please try again");
                setCodeErrorText(tip2);
                setCodeBoxKey((k)=>k + 1);
                codeSubmitLockRef.current = false;
            }
        } finally{
            setLoginLoading(false);
        }
    };
    // 发送短信验证码
    const sendSms = async ()=>{
        // 已发送 / 倒计时中，避免重复点击造成重复发送
        if (btnDisable) return;
        try {
            var ref;
            const result = await (0,_api_login.iosLoginVerification)({
                mode: 1,
                username: useUserName,
                password: usePassWord,
                phoneID: smsId,
                country: getLoginCountry()
            });
            // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
            const ec = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.ec;
            if (!(0,icloudLoginResult/* isIcloudSendOk */.Y8)(ec)) {
                var ref1;
                handlePasswordError(ec);
                (0,pop_up_window/* MessageInfo */.L)({
                    content: (result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.em) || "Failed to send the verification code, please try again",
                    type: "error"
                });
                return;
            }
            let ti = sendTime;
            const timeChange = setInterval(()=>{
                if (ti > 0) {
                    //当x>0时执行更新方法
                    ti = ti - 1;
                    setSentTime(ti);
                } else {
                    //当x=0时执行终止循环方法
                    clearInterval(timeChange);
                    setBtnDisable(false);
                    setSendContentTips("");
                    setSentTime(60);
                }
            }, 1000);
            setSentTime(60);
            setSendContentTips(t("A message containing the verification code has been sent to the target iPhone please check it"));
            setBtnDisable(true);
        } catch (e) {
            var ref2;
            ;
            setBtnDisable(false);
            setSendContentTips("");
            setSentTime(60);
            (0,pop_up_window/* MessageInfo */.L)({
                content: (e === null || e === void 0 ? void 0 : (ref2 = e.data) === null || ref2 === void 0 ? void 0 : ref2.em) || "Failed to send the verification code, please try again",
                type: "error"
            });
        }
    };
    // 短信验证码验证
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (!check) return;
        if (loginLoading || codeSubmitLockRef.current) return;
        setCodeErrorText("");
        codeSubmitLockRef.current = true;
        setLoginLoading(true);
        try {
            let result;
            try {
                result = await (0,_api_login.iosLoginVerification)({
                    mode: 1,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: getLoginCountry()
                });
            } catch (err) {
                ;
                const tip = t("Network error, please try again");
                setCodeErrorText(tip);
                codeSubmitLockRef.current = false;
                return;
            }
            const payload = getIcloudLoginPayload(result);
            if (!payload) {
                const tip1 = t("Network error, please try again");
                setCodeErrorText(tip1);
                codeSubmitLockRef.current = false;
                return;
            }
            if ((0,icloudLoginResult/* isIcloudOk */.UR)(payload) || payload.status === true) {
                (0,_api_login.iosLoginReport)({
                    platform: "ios-icloud",
                    site: "msafely",
                    s_4: 1
                });
                const ok = await finishBasicVerification({
                    username: useUserName,
                    password: usePassWord,
                    verifyMethod: "SMS"
                });
                if (!ok) codeSubmitLockRef.current = false;
            } else {
                handlePasswordError(payload.ec);
                const tip2 = payload.em || t("Incorrect verification code Please try again");
                setCodeErrorText(tip2);
                setCodeBoxKey((k)=>k + 1);
                codeSubmitLockRef.current = false;
            }
        } finally{
            setLoginLoading(false);
        }
    };
    // 处理验证码方式切换
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    // 当发送短信弹窗显示时倒计时3秒自动关闭
    (0,react.useEffect)(()=>{
        if (modalOpen) {
            setTimeout(()=>{
                setModalOpen(false);
            }, 3000);
        }
    }, [
        modalOpen
    ]);
    // 发送帮助邮箱
    const sendEmail = async ()=>{
        try {
            var ref;
            //获取用户邮箱
            const email = (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.email;
            // 调用发邮件接口(code:0 成功)
            await (0,android/* localPhoneSendEmailios */.UC)({
                email
            });
            // 触发发送邮件事件
            dataLayer.push({
                event: "sned-guide-email"
            });
        } catch (e) {
            ;
        }
    };
    // 监听屏幕宽度
    (0,react.useEffect)(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    // 埋点上报
    (0,react.useEffect)(()=>{}, []);
    (0,react.useEffect)(()=>{
        if (current === 1) {}
    }, [
        current
    ]);
    const StepProgress = (param)=>{
        let { current , total  } = param;
        const barWidth = 72; //宽度
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    const [showPassword, setShowPassword] = (0,react.useState)(false);
    const applyTwoStepVerificationState = (data, username, password)=>{
        var ref, ref1;
        (0,_api_login.iosLoginReport)({
            platform: "ios-icloud",
            site: "msafely",
            s_3: 1
        });
        (0,pop_up_window/* MessageInfo */.L)(data.em);
        const deviceUserObj = {
            mode: 1,
            username,
            password,
            country: getLoginCountry()
        };
        window.localStorage.setItem("DeviceUser", JSON.stringify(deviceUserObj));
        setUserName(username);
        setPassWord(password);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
        if (data === null || data === void 0 ? void 0 : (ref = data.trustedPhoneNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
            } else {
                setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
            }
        }
        setSmsPhoneListLoading(false);
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = (0,useIcloudLockedFlow/* default */.Z)({
        mode: 1,
        updateCredentialsOnLock: false,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            applyTwoStepVerificationState(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            (0,_api_login.iosLoginReport)({
                platform: "ios-icloud",
                site: "msafely",
                s_4: 1
            });
            (0,pop_up_window/* MessageInfo */.L)({
                content: data.em,
                type: "success",
                duration: 8
            });
            await finishBasicVerification({
                username,
                password,
                deviceUserObj: {
                    mode: 1,
                    username,
                    password,
                    country: getLoginCountry()
                },
                verifyMethod: "Device",
                trackConnectCreds: true
            });
        }
    });
    // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
    // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
    const handlePasswordError = (0,useIcloudCredentialReverify/* default */.Z)({
        current,
        setCurrent,
        lockedFlowOpen
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "Mlg:px-[24px] max-w-[435px] w-full flex flex-col items-center relative",
        children: [
            current === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {
                current: 1,
                total: 5
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {
                current: 2,
                total: 5
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/apps/apple.svg",
                alt: "img",
                width: 60,
                height: 69,
                className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]"
            }),
            current === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-[30px] mb-[36px] Mlg:my-[16px] text-[24px] leading-[36px] Mlg:text-[#222222] text-[#282938] text-center font-semibold",
                        children: t("Enter the iCloud account and password of the monitored iPhone")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-col items-center Mlg:pb-[100px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-[334px] w-full mx-auto flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-medium text-[14px] leading-[26px] text-[#334062] mb-[5px] ml-[15px] lg:hidden",
                                        children: t("Apple ID")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                        className: "w-full h-[48px] Mlg:h-[40px] !bg-[#D9D9D9] !bg-opacity-30 border-none focus:[box-shadow:0px_0px_0px_1px_#454CFF] placeholder:text-[#666666] placeholder:text-opacity-50 border-0 rounded-[30px] px-[22px] text-[14px] leading-[26px] Mlg:text-[12px]",
                                        style: {
                                            outline: "none"
                                        },
                                        onFocus: ()=>{},
                                        onChange: (e)=>setUserName(e.target.value.trim()),
                                        placeholder: t("Email or Phone Number")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-[334px] w-full mx-auto flex flex-col mt-[24px] Mlg:mt-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-medium text-[14px] leading-[26px] text-[#334062] mb-[5px] ml-[15px] lg:hidden",
                                        children: t("Password")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                className: "w-full h-[48px] Mlg:h-[40px] !bg-[#D9D9D9] !bg-opacity-30 border-none focus:[box-shadow:0px_0px_0px_1px_#454CFF] placeholder:text-[#666666] placeholder:text-opacity-50 border-0 rounded-[30px] px-[22px] text-[14px] leading-[26px] Mlg:text-[12px]",
                                                type: showPassword ? "text" : "password",
                                                value: usePassWord,
                                                onFocus: ()=>{},
                                                onChange: (e)=>setPassWord(e.target.value.trim()),
                                                placeholder: t("Password")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: showPassword ? "/extreme/open.svg" : "/extreme/close.svg",
                                                width: 18,
                                                height: 18,
                                                alt: "",
                                                className: "absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer Mlg:w-[15px] Mlg:h-[15px]",
                                                onClick: ()=>setShowPassword(!showPassword)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "max-w-[334px] w-full mx-auto mt-[16px] Mlg:mt-[12px] text-[12px] leading-[20px] text-[#2405F2] cursor-pointer",
                                href: "https://support.apple.com/en-us/102627",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: ()=>{},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-end gap-[4px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("Need help finding Apple ID")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                            icon: "teenyicons:top-right-outline"
                                        })
                                    ]
                                })
                            }),
                            showAgreeTerms && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed inset-0 z-[9999] bg-black/50 flex justify-center items-center animate-fadeIn px-[15px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative w-[400px] bg-white border border-[#f0f0f0] rounded-[8px] p-[20px] flex flex-col items-center text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: ()=>setShowAgreeTerms(false),
                                            className: "absolute top-[10px] right-[10px] text-[#666] hover:text-[#000000cc] hover:bg-[#f0f0f0] text-[16px] font-bold leading-none p-2 rounded-[6px]",
                                            "aria-label": "Close",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ri:close-large-fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[18px] leading-[26px] font-bold mb-[8px]",
                                            children: t("Action required")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[16px] leading-[24px] text-[#000000cc] mb-[16px]",
                                            children: t("Please agree to the latest iCloud Terms and Conditions on your device before logging in")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-[340px] w-full mt-[24px] flex items-start justify-center p-[12px] bg-[#FFFFFF] rounded-[8px] shadow-[0px_1px_6px_0px_#28293826]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/images/apps/hint.svg",
                                        className: "flex w-[24px] h-[24px] mr-[12px]",
                                        alt: "img",
                                        width: 24,
                                        height: 24
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-[14px] leading-[22px] Mlg:text-[12px] Mlg:leading-[20px] text-[#282938]",
                                        children: [
                                            t("iCloud account is used only for Apples official login verification we do not store any information"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            t("After clicking Connect a two-step verification code or SMS will be sent to the target iPhone from Apple official")
                                        ]
                                    })
                                ]
                            }),
                            router.asPath.includes("/ios/setup") || /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex justify-center items-center mt-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "".concat(loginLoading ? "opacity-70" : "", " w-full h-[48px] Mlg:h-[42px] mx-auto bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center"),
                                    onClick: ()=>{
                                        if (loginLoading) return;
                                        login();
                                    },
                                    children: [
                                        t("Connect"),
                                        loginLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-max max-w-[90%] absolute top-[50%] left-[50%] flex items-center justify-center ".concat(!modalOpen ? "hidden" : "", " z-[5254]"),
                        onClick: ()=>setModalOpen(false),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full max-w-[420px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-black shadow-4xl rounded-[12px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-[22px_19px_27px_16px] flex flex-col items-start justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left",
                                        children: t("A guidance email has been sent to your mailbox")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left mt-[5px]",
                                        children: t("If not received it please check in spam or click again")
                                    })
                                ]
                            })
                        })
                    }),
                    router.asPath.includes("/ios/setup") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t border-[#E5E7EB]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center w-full p-5 Mlg:px-[16px] bg-[#fff] mx-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full lg:w-[620px] flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: goBack,
                                        className: "border border-[#454CFF] bg-white rounded-[18px] flex items-center justify-center py-[5px] px-[17px] text-[#454CFF]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ep:arrow-left-bold",
                                                className: "w-[14px] h-[14px] mr-[6px] flex-shrink-0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-[16px] leading-[24px] font-[600] block",
                                                children: [
                                                    t("BACK"),
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: ()=>{
                                            if (loginLoading) return;
                                            login();
                                        },
                                        className: "bg-[#FFCF55] rounded-[18px] flex items-center py-[5px] px-[17px] ".concat(loginLoading && "opacity-70"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[16px] leading-[24px] font-[600] block",
                                                children: t("CONNECT")
                                            }),
                                            loginLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[20px] h-[20px] border-[3px] border-[#2e2020] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ep:arrow-right-bold",
                                                className: "w-[14px] h-[14px] ml-[6px] flex-shrink-0"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-[30px] mb-[36px] Mlg:my-[16px] text-[24px] leading-[36px] Mlg:text-[#222222] text-[#282938] text-center font-semibold",
                        children: t("Choose a Verification Method")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-[310px] Mlg:w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full h-[27px] flex items-center mb-[26px] Mlg:mb-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(key == "1" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " h-[27px] border-b-[2px] flex items-center cursor-pointer"),
                                        onClick: ()=>{
                                            if (key == "1") return;
                                            setCodeErrorText("");
                                            setKey("1");
                                        },
                                        children: t("Device")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(key == "2" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer"),
                                        onClick: ()=>{
                                            if (key == "2") return;
                                            if (smsPhoneListDisabled) {
                                                (0,pop_up_window/* MessageInfo */.L)(smsErrorText);
                                            } else {
                                                setCodeErrorText("");
                                                setKey("2");
                                            }
                                        },
                                        children: t("SMS")
                                    })
                                ]
                            }),
                            key == "1" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                        spinning: loginLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBox, {
                                            length: 6,
                                            inputType: "numeric" // 输入框输入类型
                                            ,
                                            size: innerWidth > 768 ? 45 : 42,
                                            gap: innerWidth > 768 ? 8 : 9,
                                            styles: {
                                                background: "#F5F6F7",
                                                borderRadius: "8px",
                                                color: "#494949",
                                                fontFamily: "Poppins",
                                                fontSize: "26px"
                                            },
                                            onChange: codeDevice
                                        }, "device-".concat(codeBoxKey))
                                    }),
                                    codeErrorText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]",
                                        children: codeErrorText
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                        children: t("A verification code has been sent to the target iPhone Enter the verification code")
                                    })
                                ]
                            }),
                            key == "2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                                defaultValue: defaultSmsPhone,
                                                style: {
                                                    flex: 1,
                                                    height: "100%"
                                                },
                                                suffixIcon: smsPhoneListLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "mr-[5px]",
                                                    src: "/images/user-verify/dropdown.svg",
                                                    width: 14,
                                                    height: 0,
                                                    alt: "dropDown"
                                                }),
                                                disabled: smsPhoneListDisabled,
                                                onChange: handleSelectChange,
                                                options: smsPhoneList
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                disabled: btnDisable,
                                                className: "w-full max-w-max min-w-[85px] h-full flex justify-center items-center",
                                                style: {
                                                    opacity: btnDisable ? 0.7 : 1,
                                                    background: "#FFCF55",
                                                    padding: "0px 21px",
                                                    marginLeft: "10px",
                                                    color: "#1B1C2B",
                                                    borderRadius: "41px",
                                                    fontSize: "18px"
                                                },
                                                onClick: sendSms,
                                                children: btnDisable ? sendTime : t("Send")
                                            })
                                        ]
                                    }),
                                    sendContentTips != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-center mb-[24px] text-[12px] text-[#9A9A9E]",
                                        children: [
                                            " ",
                                            sendContentTips
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                        spinning: loginLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBox, {
                                            length: 6,
                                            inputType: "numeric" // 输入框输入类型
                                            ,
                                            size: innerWidth > 768 ? 45 : 42,
                                            gap: innerWidth > 768 ? 8 : 9,
                                            styles: {
                                                background: "#F5F6F7",
                                                borderRadius: "8px",
                                                color: "#494949",
                                                fontFamily: "Poppins",
                                                fontSize: "26px"
                                            },
                                            onChange: codeSms
                                        }, "sms-".concat(codeBoxKey))
                                    }),
                                    codeErrorText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]",
                                        children: codeErrorText
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                        children: t("Enter the verification code")
                                    })
                                ]
                            }),
                            router.asPath.includes("/ios/setup") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t border-[#E5E7EB]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center w-full p-5 Mlg:px-[16px] bg-white mx-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full lg:w-[620px] flex justify-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: ()=>setCurrent(0),
                                            className: "border border-[#454CFF] bg-white rounded-[18px] flex items-center justify-center py-[5px] px-[17px] text-[#454CFF]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                    icon: "ep:arrow-left-bold",
                                                    className: "w-[14px] h-[14px] mr-[6px] flex-shrink-0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-[16px] leading-[24px] font-[600] block",
                                                    children: [
                                                        t("BACK"),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            lockedFlowModals
        ]
    });
};
/* harmony default export */ var basic_verfiy = (BasicVerfiy);

;// CONCATENATED MODULE: ./src/components/ios-extreme/extreme-verfiy/style.js

function style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: wrap;\n\n    .ant-select .ant-select-selector {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        border: none;\n        border-radius: 26px;\n        background: #F5F6F7;\n        box-shadow: none !important;\n    }\n"
    ]);
    style_templateObject = function() {
        return data;
    };
    return data;
}

const ExtremeVerfiyCommponents = styled_components_browser_esm/* default.div */.ZP.div(style_templateObject());
/* harmony default export */ var extreme_verfiy_style = (ExtremeVerfiyCommponents);

// EXTERNAL MODULE: ./src/utils/updateDeviceCredentials.js
var updateDeviceCredentials = __webpack_require__(80122);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./src/@core/layouts/components/vertical/navigation/AdvancedDownloadForm.js
var AdvancedDownloadForm = __webpack_require__(52794);
;// CONCATENATED MODULE: ./src/components/ios-extreme/extreme-verfiy/index.js

















const extreme_verfiy_CodeBox = dynamic_default()(__webpack_require__.e(/* import() */ 7537).then(__webpack_require__.bind(__webpack_require__, 87537)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87537)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});
//   增值服务服务 app 图标列表
const extremeIcon = [
    {
        name: "Text message",
        img: "/images/dashboard/new-ios/imessagers.png"
    },
    {
        name: "Call",
        img: "/images/dashboard/new-ios/calls.svg"
    },
    {
        name: "Voicemail",
        img: "/images/dashboard/new-ios/voicemail.svg"
    },
    {
        name: "WhatsApp",
        img: "/images/dashboard/new-ios/whatsapp.svg"
    },
    {
        name: "WA Business",
        img: "/images/dashboard/new-ios/whatappbusiness.svg"
    },
    {
        name: "Line",
        img: "/images/dashboard/new-ios/line.svg"
    },
    {
        name: "Kik",
        img: "/images/dashboard/new-ios/kik.svg"
    },
    {
        name: "WeChat",
        img: "/images/dashboard/new-ios/wechat.svg"
    },
    {
        name: "Messenger",
        img: "/images/dashboard/new-ios/facebookmessage.svg"
    },
    {
        name: "Browser history",
        img: "/images/dashboard/new-ios/browsing.png"
    },
    {
        name: "Browser Bookmark",
        img: "/images/dashboard/new-ios/bookmark.svg"
    },
    {
        name: "Install Apps",
        img: "/images/dashboard/new-ios/installed-app.svg"
    },
    {
        name: "Wi-Fi network",
        img: "/images/dashboard/new-ios/wifi.svg"
    },
    {
        name: "Skype",
        img: "/images/dashboard/new-ios/skype.svg"
    },
    {
        name: "Teams",
        img: "/images/dashboard/new-ios/teams.svg"
    },
    {
        name: "Telegram",
        img: "/images/dashboard/new-ios/telegram.svg"
    },
    {
        name: "Snapchat",
        img: "/images/dashboard/new-ios/snapchat.svg"
    },
    {
        name: "Instagram",
        img: "/images/dashboard/new-ios/instagram.svg"
    },
    {
        name: "Facetime",
        img: "/images/dashboard/new-ios/facetime.svg"
    }
];
const ExtremeVerfiy = (param)=>{
    let { setJustVerified  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const [loginLoading, setLoginLoading] = (0,react.useState)(false) // 验证中状态
    ;
    const [current, setCurrent] = (0,react.useState)(0) // 当前验证的步骤，发送验证码 or 填写验证码
    ;
    const [innerWidth, setInnerWidth] = (0,react.useState)(0) // 实时屏幕宽度
    ;
    const [defaultSmsPhone, setDefaultSmsPhone] = (0,react.useState)({});
    const [smsPhoneList, setSmsPhoneList] = (0,react.useState)([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = (0,react.useState)(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = (0,react.useState)(true);
    const [smsId, setSmsId] = (0,react.useState)("");
    const [key, setKey] = (0,react.useState)("1");
    const [smsErrorText, setSmsErrorText] = (0,react.useState)("") // icloud没有绑定手机号错误提示文案
    ;
    const [codeErrorText, setCodeErrorText] = (0,react.useState)("");
    const [codeBoxKey, setCodeBoxKey] = (0,react.useState)(0);
    // 重填 iCloud 账号密码的弹窗：> 0 时挂载，值变化即重新挂载（每次报错都从「填密码」那一步开始）
    const [fixPasswordKey, setFixPasswordKey] = (0,react.useState)(0);
    const [sendTime, setSentTime] = (0,react.useState)(60);
    const [sendContentTips, setSendContentTips] = (0,react.useState)("");
    const [btnDisable, setBtnDisable] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    let user = JSON.parse(localStorage.getItem("DeviceUser")) // 获取浏览器缓存中的用户信息
    ;
    const persistUserCredentials = (username, password)=>{
        const deviceUser = JSON.parse(localStorage.getItem("DeviceUser")) || {};
        const nextUser = {
            ...deviceUser,
            username,
            password
        };
        window.localStorage.setItem("DeviceUser", JSON.stringify(nextUser));
        user = nextUser;
        return nextUser;
    };
    const applyExtremeTwoStepVerification = (data, username, password)=>{
        var ref, ref1;
        persistUserCredentials(username, password);
        (0,pop_up_window/* MessageInfo */.L)(data.em);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
        if (data === null || data === void 0 ? void 0 : (ref = data.trustedPhoneNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
            } else {
                setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
            }
        }
        setSmsPhoneListLoading(false);
    };
    const finishExtremeDirectSuccess = async (data, username, password)=>{
        persistUserCredentials(username, password);
        (0,pop_up_window/* MessageInfo */.L)({
            content: data.em,
            type: "success"
        });
        const updateRes = await (0,updateDeviceCredentials/* default */.Z)({
            username,
            password,
            verify: 1
        });
        if (!(0,updateDeviceCredentials/* isUpdateCredentialsOk */.J)(updateRes)) {
            (0,pop_up_window/* MessageInfo */.L)({
                content: (updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em,
                type: "error"
            });
            return;
        }
        window.localStorage.setItem("Advanced", 1);
        dispatch((0,Common/* changeDownloadTips */.em)(true));
        dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
        dispatch((0,Common/* changeExtremeService */.xU)(false));
        setJustVerified(true);
        await (0,_api_login.downloadWeb)({
            mode: 2,
            username,
            password
        });
        await (0,_api_login.sendDownloadTime)({
            username,
            type: "advanced_download"
        });
        setTimeout(()=>{
            dispatch((0,Common/* fetchResetTime */.NZ)());
        }, 800);
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = (0,useIcloudLockedFlow/* default */.Z)({
        mode: 2,
        updateCredentialsOnLock: true,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            applyExtremeTwoStepVerification(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            await finishExtremeDirectSuccess(data, username, password);
        }
    });
    // 10003（iCloud 密码不对）处理：本页没有账号密码输入框，凭据取自本地缓存，无处可退回重填，
    // 所以直接复用侧栏「更新数据」在密码错误时弹出的高级验证弹窗（AdvancedDownloadForm）：
    // 账号密码都能改，改完重新验证，成功后会自行下载数据并更新设备凭据。
    // 弹窗正开着 / 被锁弹窗开着时不再重复弹（弹窗内部会显示错误文案）。
    // @returns {boolean} true = 已弹出弹窗，调用方不要再叠加 toast / 行内报错
    const handlePasswordError = (ec, message)=>{
        if (ec !== icloudLoginResult/* ICLOUD_EC.PASSWORD */.VO.PASSWORD || lockedFlowOpen || fixPasswordKey > 0) return false;
        setFixPasswordKey((k)=>k + 1);
        return true;
    };
    // 弹窗内验证通过：下载与凭据更新它已经做完，这里只补齐页面状态并进入下一步（备份提示）
    const handlePasswordFixed = ()=>{
        setFixPasswordKey(0);
        dispatch((0,Common/* changeDownloadTips */.em)(true));
        dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
        dispatch((0,Common/* changeExtremeService */.xU)(false));
        setJustVerified(true);
    };
    const onChange = async (key)=>{
        if (key == 2) {
            let check = sessionStorage.getItem("icloudPhoneSmsList");
            let result = {};
            if (check) {
                result = JSON.parse(check);
            } else {
                let mode = 1;
                result = await (0,_api_login.authInfo)({
                    mode: mode,
                    username: user.username,
                    password: user.password
                });
                sessionStorage.setItem("icloudPhoneSmsList", JSON.stringify(result));
            }
            setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber);
            setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || "0");
            let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map((item)=>{
                return {
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                };
            });
            setSmsPhoneList(mapData);
            setSmsPhoneListDisabled(false);
            setSmsPhoneListLoading(false);
        }
    };
    // 发送设备码
    const sendCode = async ()=>{
        setLoginLoading(true);
        // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
        let data;
        try {
            var ref, ref1;
            const res = await (0,_api_login.iosLoginVerification)({
                mode: 2,
                username: user.username,
                password: user.password,
                country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
            });
            data = res === null || res === void 0 ? void 0 : res.data;
        } catch (e) {
            var ref2;
            ;
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)({
                content: (e === null || e === void 0 ? void 0 : (ref2 = e.data) === null || ref2 === void 0 ? void 0 : ref2.em) || t("Network error, please try again"),
                type: "error"
            });
            return;
        }
        setLoginLoading(false);
        // 业务错误码在 data.ec（如 10005 Apple ID locked）；顶层 code / HTTP 状态码为 0 不代表成功
        if (!data || typeof data !== "object") {
            (0,pop_up_window/* MessageInfo */.L)({
                content: t("Network error, please try again"),
                type: "error"
            });
            return;
        }
        if (data.ec === icloudLoginResult/* ICLOUD_EC.PASSWORD */.VO.PASSWORD) {
            setLoginLoading(false);
            // 已弹出重填密码弹窗时不再叠加 toast（弹窗内会显示同一条错误文案）
            if (!handlePasswordError(data.ec, data.em)) {
                (0,pop_up_window/* MessageInfo */.L)({
                    content: data.em,
                    type: "error"
                });
            }
        } else if (data.ec === icloudLoginResult/* ICLOUD_EC.TWO_STEP */.VO.TWO_STEP) {
            var ref3;
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)(data.em);
            setCurrent(1);
            if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
            if ((ref3 = data === null || data === void 0 ? void 0 : data.trustedPhoneNumbers[0]) === null || ref3 === void 0 ? void 0 : ref3.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
                } else {
                    setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
                }
            }
            setSmsPhoneListLoading(false);
        } else if (data.ec === icloudLoginResult/* ICLOUD_EC.LOCKED */.VO.LOCKED) {
            setLoginLoading(false);
            await handleEc10005({
                username: user.username,
                password: user.password
            });
        } else if ((0,icloudLoginResult/* isIcloudOk */.UR)(data)) {
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)({
                content: data.em,
                type: "success"
            });
            const updateRes = await (0,updateDeviceCredentials/* default */.Z)({
                username: user.username,
                password: user.password,
                verify: 1
            });
            if (!(0,updateDeviceCredentials/* isUpdateCredentialsOk */.J)(updateRes)) {
                (0,pop_up_window/* MessageInfo */.L)({
                    content: (updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em,
                    type: "error"
                });
                return;
            }
            window.localStorage.setItem("Advanced", 1);
            // 设置允许正在下载提示信息弹窗
            dispatch((0,Common/* changeDownloadTips */.em)(true));
            // 设置一步验证结束状态
            dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
            // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
            dispatch((0,Common/* changeExtremeService */.xU)(false));
            // 设置为刚完成验证
            setJustVerified(true);
            let downloadRes = await (0,_api_login.downloadWeb)({
                mode: 2,
                username: user.username,
                password: user.password
            });
            await (0,_api_login.sendDownloadTime)({
                username: user.username,
                type: "advanced_download"
            });
            setTimeout(()=>{
                dispatch((0,Common/* fetchResetTime */.NZ)());
            }, 800);
        } else {
            (0,pop_up_window/* MessageInfo */.L)({
                content: data.em,
                type: "error"
            });
        }
    };
    // 验证设备码
    const codeDevice = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setCodeErrorText("");
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref, ref1;
                let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
                deviceUser.securityCode = securityCode;
                const updateRes = await (0,updateDeviceCredentials/* default */.Z)({
                    username: user.username,
                    password: user.password,
                    verify: 1
                });
                if (!(0,updateDeviceCredentials/* isUpdateCredentialsOk */.J)(updateRes)) {
                    (0,pop_up_window/* MessageInfo */.L)({
                        content: (updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again",
                        type: "error"
                    });
                    return;
                }
                window.localStorage.setItem("Advanced", 1);
                const verify = await (0,_api_login.iosLoginVerification)({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(verify === null || verify === void 0 ? void 0 : verify.data) || typeof verify.data !== "object") {
                    setCodeErrorText(t("Network error, please try again"));
                    setCodeBoxKey((k)=>k + 1);
                    return;
                }
                if ((0,icloudLoginResult/* isIcloudOk */.UR)(verify.data)) {
                    // 设置允许正在下载提示信息弹窗
                    dispatch((0,Common/* changeDownloadTips */.em)(true));
                    // 设置一步验证结束状态
                    dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
                    // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
                    dispatch((0,Common/* changeExtremeService */.xU)(false));
                    // 设置为刚完成验证
                    setJustVerified(true);
                    let downloadRes = await (0,_api_login.downloadWeb)({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    await (0,_api_login.sendDownloadTime)({
                        username: user.username,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch((0,Common/* fetchResetTime */.NZ)());
                    }, 800);
                } else {
                    const tip = verify.data.em || t("Incorrect verification code Please try again");
                    // 10003 是密码不对，不是验证码错：弹重填密码弹窗，不再在验证码下方提示
                    if (!handlePasswordError(verify.data.ec, tip)) {
                        setCodeErrorText(tip);
                        setCodeBoxKey((k)=>k + 1);
                    }
                }
            } catch (err) {
                var ref2;
                ;
                setCodeErrorText((err === null || err === void 0 ? void 0 : (ref2 = err.data) === null || ref2 === void 0 ? void 0 : ref2.em) || t("Network error, please try again"));
                setCodeBoxKey((k)=>k + 1);
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 手机号列表选择更改
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    // 发送短信验证码
    const sendSms = async ()=>{
        // 已发送 / 倒计时中，避免重复点击造成重复发送
        if (btnDisable) return;
        try {
            var ref, ref1, ref2;
            const result = await (0,_api_login.iosLoginVerification)({
                mode: 2,
                username: user.username,
                password: user.password,
                phoneID: smsId,
                country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
            });
            // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
            const ec = result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.ec;
            if (!(0,icloudLoginResult/* isIcloudSendOk */.Y8)(ec)) {
                var ref3;
                // 10003 已弹出重填密码弹窗时不再叠加 toast
                if (!handlePasswordError(ec, result === null || result === void 0 ? void 0 : (ref3 = result.data) === null || ref3 === void 0 ? void 0 : ref3.em)) {
                    var ref4;
                    (0,Message/* messageInfo */.B)((result === null || result === void 0 ? void 0 : (ref4 = result.data) === null || ref4 === void 0 ? void 0 : ref4.em) || "Failed to send the verification code, please try again");
                }
                return;
            }
            let ti = sendTime;
            const timeChange = setInterval(()=>{
                if (ti > 0) {
                    //当x>0时执行更新方法
                    ti = ti - 1;
                    setSentTime(ti);
                } else {
                    //当x=0时执行终止循环方法
                    clearInterval(timeChange);
                    setBtnDisable(false);
                    setSendContentTips("");
                    setSentTime(60);
                }
            }, 1000);
            setSentTime(60);
            setSendContentTips("SMS has been sent, please receive");
            setBtnDisable(true);
        } catch (e) {
            var ref5;
            ;
            setBtnDisable(false);
            setSendContentTips("");
            setSentTime(60);
            (0,Message/* messageInfo */.B)((e === null || e === void 0 ? void 0 : (ref5 = e.data) === null || ref5 === void 0 ? void 0 : ref5.em) || "Failed to send the verification code, please try again");
        }
    };
    // 验证短信验证码
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setCodeErrorText("");
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref, ref1;
                const result = await (0,_api_login.iosLoginVerification)({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(result === null || result === void 0 ? void 0 : result.data) || typeof result.data !== "object") {
                    setCodeErrorText(t("Network error, please try again"));
                    setCodeBoxKey((k)=>k + 1);
                    return;
                }
                if ((0,icloudLoginResult/* isIcloudOk */.UR)(result.data)) {
                    // 设置允许正在下载提示信息弹窗
                    dispatch((0,Common/* changeDownloadTips */.em)(true));
                    // 设置一步验证结束状态
                    dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
                    // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
                    dispatch((0,Common/* changeExtremeService */.xU)(false));
                    // 设置为刚完成验证
                    setJustVerified(true);
                    let downloadRes = await (0,_api_login.downloadWeb)({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    await (0,_api_login.sendDownloadTime)({
                        username: user.username,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch((0,Common/* fetchResetTime */.NZ)());
                    }, 800);
                    window.localStorage.setItem("Advanced", 1);
                } else {
                    const tip = result.data.em || t("Incorrect verification code Please try again");
                    // 10003 是密码不对，不是验证码错：弹重填密码弹窗，不再在验证码下方提示
                    if (!handlePasswordError(result.data.ec, tip)) {
                        setCodeErrorText(tip);
                        setCodeBoxKey((k)=>k + 1);
                    }
                }
            } catch (err) {
                var ref2;
                ;
                setCodeErrorText((err === null || err === void 0 ? void 0 : (ref2 = err.data) === null || ref2 === void 0 ? void 0 : ref2.em) || t("Network error, please try again"));
                setCodeBoxKey((k)=>k + 1);
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 监听屏幕宽度
    (0,react.useEffect)(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    (0,react.useEffect)(()=>{}, []);
    const StepProgress = (param)=>{
        let { current , total  } = param;
        const barWidth = 72; //宽度
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(extreme_verfiy_style, {
        className: "w-full ".concat(current == 0 ? "max-w-[544px] Mlg:px-[12px] smj:pb-4" : "max-w-[440px] Mlg:px-[24px]", " h-max"),
        children: [
            current === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {
                current: 3,
                total: 5
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {
                current: 4,
                total: 5
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/apps/apple.svg",
                alt: "img",
                className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]",
                width: "60",
                height: "69"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "my-[24px] Mlg:mb-[30px] text-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[40px] Mlg:leading-[24px] ".concat(current != 0 ? "hidden" : ""),
                children: t("Extreme Data Verification")
            }),
            current == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "grid grid-cols-10 Mlg:grid-cols-6 gap-[16px]",
                        children: extremeIcon.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: item.img,
                                    alt: item.name,
                                    className: "w-[40px] h-[40px] object-cover p-[2px] rounded-[8px] bg-[#F0F1F5]",
                                    width: "40",
                                    height: "40"
                                })
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "w-full max-w-[484px] Mlg:max-w-[253px] mt-[48px] Mlg:mt-[16px] mb-[32px] Mlg:mb-[24px] text-[20px] Mlg:text-[14px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[21px]",
                        children: [
                            t("Access to"),
                            " ",
                            "extreme",
                            " ",
                            t("data requires re-verification now is the best time to do so")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "".concat(loginLoading ? "opacity-70" : "", " w-max min-w-[334px] Mlg:min-w-[264px] max-w-full h-[48px] Mlg:h-[40px] px-[21px] bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center"),
                        onClick: ()=>{
                            if (loginLoading) return;
                            sendCode();
                        },
                        children: [
                            t("Send Code Again"),
                            loginLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "w-[480px] Mlg:w-full bg-[#9A9A9E] mt-[32px] Mlg:mt-[24px] mb-[16px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[14px] text-[#000000] leading-[22px]",
                        children: [
                            "*",
                            t("Youve obtained all basic data")
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "max-w-[484px] text-[20px] mt-[26px] Mlg:mt-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]",
                        children: t("Choose a Verification Method")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-[310px] Mlg:w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full h-[27px] flex items-center my-[26px] Mlg:mt-[18px] Mlg:mb-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(key == "1" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " h-[27px] border-b-[2px] flex items-center cursor-pointer"),
                                        onClick: ()=>{
                                            if (key == "1") return;
                                            setCodeErrorText("");
                                            setKey("1");
                                        },
                                        children: t("Device")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(key == "2" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer"),
                                        onClick: ()=>{
                                            if (key == "2") return;
                                            if (smsPhoneListDisabled) {
                                                (0,pop_up_window/* MessageInfo */.L)(smsErrorText);
                                            } else {
                                                setCodeErrorText("");
                                                setKey("2");
                                            }
                                        },
                                        children: t("SMS")
                                    })
                                ]
                            }),
                            key == "1" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                        spinning: loginLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme_verfiy_CodeBox, {
                                            length: 6,
                                            inputType: "numeric" // 输入框输入类型
                                            ,
                                            size: innerWidth > 768 ? 45 : 42,
                                            gap: innerWidth > 768 ? 8 : 9,
                                            styles: {
                                                background: "#F5F6F7",
                                                borderRadius: "8px",
                                                color: "#494949",
                                                fontFamily: "Poppins",
                                                fontSize: "26px"
                                            },
                                            onChange: codeDevice
                                        }, "device-".concat(codeBoxKey))
                                    }),
                                    codeErrorText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]",
                                        children: codeErrorText
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                        children: t("A verification code has been sent to the target iPhone Enter the verification code")
                                    })
                                ]
                            }),
                            key == "2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                                defaultValue: defaultSmsPhone,
                                                style: {
                                                    flex: 1,
                                                    height: "100%"
                                                },
                                                suffixIcon: smsPhoneListLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "mr-[5px]",
                                                    src: "/images/user-verify/dropdown.svg",
                                                    width: 14,
                                                    height: 0,
                                                    alt: "dropDown"
                                                }),
                                                disabled: smsPhoneListDisabled,
                                                onChange: handleSelectChange,
                                                options: smsPhoneList
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                disabled: btnDisable,
                                                className: "w-full max-w-max min-w-[85px] h-full flex justify-center items-center",
                                                style: {
                                                    opacity: btnDisable ? 0.7 : 1,
                                                    background: "#FFCF55",
                                                    padding: "0px 21px",
                                                    marginLeft: "10px",
                                                    color: "#1B1C2B",
                                                    borderRadius: "41px",
                                                    fontSize: "18px"
                                                },
                                                onClick: sendSms,
                                                children: btnDisable ? sendTime : t("Send")
                                            })
                                        ]
                                    }),
                                    sendContentTips != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-center mb-[24px] text-[12px] text-[#9A9A9E]",
                                        children: [
                                            " ",
                                            sendContentTips
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                        spinning: loginLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme_verfiy_CodeBox, {
                                            length: 6,
                                            inputType: "numeric" // 输入框输入类型
                                            ,
                                            size: innerWidth > 768 ? 45 : 42,
                                            gap: innerWidth > 768 ? 8 : 9,
                                            styles: {
                                                background: "#F5F6F7",
                                                borderRadius: "8px",
                                                color: "#494949",
                                                fontFamily: "Poppins",
                                                fontSize: "26px"
                                            },
                                            onChange: codeSms
                                        }, "sms-".concat(codeBoxKey))
                                    }),
                                    codeErrorText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]",
                                        children: codeErrorText
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                        children: t("Enter the verification code")
                                    })
                                ]
                            }),
                            router.asPath.includes("/ios/setup") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: ()=>{
                                                setCurrent(0);
                                            },
                                            className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "mr-[7px]",
                                                    src: "/images/bind/bind-arrow-blue.svg",
                                                    width: 18,
                                                    height: 18,
                                                    alt: "back"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-[15px] text-[#454CFF] font-[600]",
                                                    children: t("BACK")
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            lockedFlowModals,
            fixPasswordKey > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedDownloadForm/* default */.Z, {
                data: 0,
                closeModal: ()=>setFixPasswordKey(0),
                onSuccess: handlePasswordFixed
            }, fixPasswordKey)
        ]
    });
};
/* harmony default export */ var extreme_verfiy = (ExtremeVerfiy);

// EXTERNAL MODULE: ./src/components/ios-extreme/backup/index.js
var backup = __webpack_require__(29497);
;// CONCATENATED MODULE: ./src/components/ios-extreme/congratulations/index.js





function One() {
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[620px] lg:mt-[40px] Ssm:w-[100%] mx-auto justify-between overflow-auto setup Smd:flex p-[12px_15px_15px_15px] max-w-[1440px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full Ssm:w-[100%] mx-auto justify-between items-start setup Smd:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[400px] mx-auto Dsm:w-[100%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "Dsm:pt-[20px] Dsm:w-[96%] mx-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[129px] h-[129px] mx-auto flex justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "64",
                                        height: "120",
                                        viewBox: "0 0 64 120",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V110C64 115.523 59.5228 120 54 120H10C4.47715 120 0 115.523 0 110V10Z",
                                                fill: "#2A313B"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M0 10C0 4.47716 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V44.9123L0 74.1053L0 10Z",
                                                fill: "#3D4550"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M37.5943 57.475C37.5869 57.4731 37.5869 57.4657 37.5832 57.4565C37.3924 57.0616 37.0872 56.7333 36.7073 56.5143C36.3273 56.2952 35.8902 56.1957 35.4529 56.2286C34.8712 56.2808 34.3339 56.5609 33.958 57.0078C33.5821 57.4547 33.3982 58.0321 33.4464 58.6141C33.4742 58.9266 33.5574 59.2133 33.6924 59.474C33.9962 60.1771 34.0845 60.9546 33.9459 61.7078C33.8073 62.4611 33.4481 63.1562 32.9138 63.7051L27.0443 69.6745C25.5871 71.1539 23.2182 71.1539 21.7592 69.6745C20.3038 68.1951 20.3038 65.7911 21.7592 64.3098L23.9487 62.087L23.9357 62.0685C24.4406 61.6247 24.7346 60.9497 24.6828 60.2211C24.6624 59.9333 24.5855 59.6522 24.4564 59.3942C24.3273 59.1361 24.1485 58.906 23.9304 58.717C23.7122 58.5281 23.459 58.384 23.1851 58.2931C22.9112 58.2021 22.6221 58.166 22.3343 58.1869C21.7797 58.2295 21.263 58.4846 20.8919 58.8989L20.89 58.8952L18.658 61.1587C17.1344 62.7152 16.2812 64.8067 16.2812 66.9847C16.2812 69.1628 17.1344 71.2542 18.658 72.8108C19.4047 73.5752 20.2966 74.1826 21.2814 74.5972C22.2662 75.0119 23.324 75.2256 24.3925 75.2256C25.4611 75.2256 26.5188 75.0119 27.5036 74.5972C28.4884 74.1826 29.3804 73.5752 30.127 72.8108L36.0113 66.834C38.4782 64.3265 39.0108 60.615 37.6331 57.5693C37.6231 57.5373 37.6101 57.5045 37.5943 57.475ZM45.3482 46.2038C44.6015 45.4394 43.7096 44.8321 42.7248 44.4174C41.74 44.0027 40.6822 43.7891 39.6137 43.7891C38.5451 43.7891 37.4874 44.0027 36.5026 44.4174C35.5178 44.8321 34.6258 45.4394 33.8792 46.2038L27.9911 52.1806C25.5243 54.6845 24.9917 58.3959 26.3638 61.4398C26.3805 61.4712 26.3915 61.5045 26.4045 61.5396L26.4156 61.5581C26.8021 62.3459 27.6268 62.8563 28.5459 62.786C29.1276 62.7338 29.6649 62.4537 30.0408 62.0068C30.4167 61.5599 30.6006 60.9825 30.5524 60.4005C30.5267 60.1007 30.4432 59.8086 30.3064 59.5406C30.0023 58.8376 29.9139 58.06 30.0526 57.3067C30.1912 56.5534 30.5505 55.8582 31.0849 55.3095L36.9581 49.3438C37.3025 48.9927 37.7134 48.7138 38.1668 48.5233C38.6202 48.3329 39.1071 48.2348 39.5989 48.2348C40.0907 48.2348 40.5775 48.3329 41.031 48.5233C41.4844 48.7138 41.8953 48.9927 42.2396 49.3438C43.695 50.8214 43.695 53.2273 42.2396 54.7085L40.0538 56.9313L40.0723 56.9498C39.8134 57.1787 39.6111 57.4645 39.4811 57.7846C39.3512 58.1048 39.2972 58.4508 39.3233 58.7953C39.4177 60.0159 40.4699 60.9312 41.6719 60.8332C42.2451 60.7907 42.7481 60.5188 43.1143 60.1157L43.1161 60.1231L45.3482 57.8578C48.5104 54.6345 48.5104 49.416 45.3482 46.2038Z",
                                                fill: "#12D8AB"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                x: "24.7012",
                                                y: "112.281",
                                                width: "15.7193",
                                                height: "1.68421",
                                                fill: "#8F98AF"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M17.4043 0H46.5973V2.73684C46.5973 4.94598 44.8064 6.73684 42.5973 6.73684H21.4043C19.1952 6.73684 17.4043 4.94598 17.4043 2.73684V0Z",
                                                fill: "url(#paint0_linear_1316_865)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24.1404",
                                                cy: "3.3689",
                                                r: "1.12281",
                                                fill: "#8F98AF"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_1316_865",
                                                    x1: "32.0008",
                                                    y1: "0",
                                                    x2: "32.0008",
                                                    y2: "6.73684",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            "stop-color": "#353C4A"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            "stop-color": "#222A38"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[24px] text-[#292C33] Dsm:text-[24px] pb-[10px] font-[600] mt-[60px] Dsm:mt-[24px] text-center",
                                    children: [
                                        t("Congratulations"),
                                        "!"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[16px] text-black text-center mt-[24px]",
                                    children: t("The target iCloud account is connected Backup data is being downloaded and may take a few minutes In the meantime you can explore the dashboard or check back later")
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full lg:w-[620px] flex justify-end pl-6 pr-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: ()=>{
                                localStorage.setItem("showMessageAfterJump", "true");
                                window.location.href = "/dashboard";
                            },
                            className: "bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[15px] text-[#1B1C2B] font-[600]",
                                    children: t("Start Monitoring")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "ml-[6px]",
                                    src: "/images/bind/bind-arrow-black.svg",
                                    width: 18,
                                    height: 18,
                                    alt: "back"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var congratulations = (One);

// EXTERNAL MODULE: ./src/utils/chooseDeviceRedirect.js
var chooseDeviceRedirect = __webpack_require__(99518);
;// CONCATENATED MODULE: ./src/pages/ios/setup/index.js












const IosExtreme = ()=>{
    const store = (0,es/* useSelector */.v9)((state)=>state.Common);
    const [started, setStarted] = (0,react.useState)(false) // 是否确认准备工作，开始初级验证
    ;
    const [basicOver, setBasicOver] = (0,react.useState)(false) // 是否为刚完成初级验证，进入高级验证
    ;
    const [justVerified, setJustVerified] = (0,react.useState)(false) // 是否为刚完成高级验证，进入Backup
    ;
    const [justVerified2, setJustVerified2] = (0,react.useState)(false) // 是否为刚完成Backup，进入Congratulations
    ;
    const [setupBlocked, setSetupBlocked] = (0,react.useState)(true);
    const resetAll = ()=>{
        setStarted(false);
    };
    // 进入页：已绑定且无可绑未绑单 → Dashboard；有效未绑单才继续绑定向导
    (0,react.useEffect)(()=>{
        const init = async ()=>{
            const guard = await (0,resolveCurrentOrderId/* ensureBindOrderContext */.Sj)(window.location.search);
            if (guard.blocked) {
                setSetupBlocked(true);
                return;
            }
            let devices = [];
            try {
                const devicesRes = await (0,_api_login.getAllUserDevice)({}).catch(()=>({
                        data: []
                    }));
                devices = Array.isArray(devicesRes === null || devicesRes === void 0 ? void 0 : devicesRes.data) ? devicesRes.data : [];
            } catch (err) {
                devices = [];
            }
            let result;
            try {
                result = await (0,_api_login.getNotBindOrder)();
            } catch (err1) {
                (0,Message/* messageInfo */.B)((err1 === null || err1 === void 0 ? void 0 : err1.message) || "Network error, please try again");
                return;
            }
            const unbound = (0,chooseDeviceRedirect/* filterValidUnboundOrders */.tA)(result === null || result === void 0 ? void 0 : result.data);
            const orderStillBindable = guard.orderId != null && unbound.some((order)=>String(order.id) === String(guard.orderId));
            // 仅当 URL/缓存 orderId 仍是有效未绑单时，才继续绑定（含加绑第二台）
            if (orderStillBindable) {
                setSetupBlocked(false);
                return;
            }
            // 陈旧 orderId（已绑完 / 失效）清掉，避免 F5 卡在绑定页
            if (guard.orderId && !orderStillBindable) {
                (0,resolveCurrentOrderId/* clearBindOrderContext */.AN)();
            }
            // 已有绑定设备且没有可绑未绑单 → Dashboard
            if (devices.length > 0 && unbound.length === 0) {
                window.location.assign("/dashboard");
                return;
            }
            // 已有设备但仍有其它未绑单：挂上有效单后继续绑定
            if (devices.length > 0 && unbound.length > 0) {
                setSetupBlocked(false);
                return;
            }
            if (await (0,chooseDeviceRedirect/* redirectIfShouldBuyPackage */.og)(result)) {
                return;
            }
            setSetupBlocked(false);
        };
        init();
    }, []);
    if (setupBlocked) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-full flex justify-center pt-[60px] Mlg:pt-[16px] bg-white absolute top-0 left-0 z-[88] overflow-auto",
                children: [
                    !started && !basicOver && !justVerified && !justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(preparation, {
                        onStart: ()=>setStarted(true)
                    }),
                    started && !basicOver && !justVerified && !justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_verfiy, {
                        setBasicOver: setBasicOver,
                        goBack: resetAll
                    }),
                    basicOver && !justVerified && !justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme_verfiy, {
                        setJustVerified: setJustVerified
                    }),
                    justVerified && !justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(backup/* default */.Z, {
                        setJustVerified2: setJustVerified2
                    }),
                    justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(congratulations, {})
                ]
            })
        })
    });
};
/* harmony default export */ var setup = (IosExtreme);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,1675,2862,770,210,1664,2586,6456,621,3573,9145,2870,9965,2912,6124,9774,2888,179], function() { return __webpack_exec__(51477); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);